"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var actions_1 = require("../../../redux/reducers/interactive-games/actions");
var action_type_util_1 = require("../../action-type.util");
var INITIAL_STATE = {
    loading: false,
    gameConfig: {},
    errorMessage: null,
    playForPointsActivity: null,
    digitalRevealGamesPaging: {}
};
exports.default = (function (state, action) {
    if (state === void 0) { state = INITIAL_STATE; }
    switch (action.type) {
        case (0, action_type_util_1.REQUEST)(actions_1.GET_GAME_CONFIG):
        case (0, action_type_util_1.REQUEST)(actions_1.UPDATE_GAME_CONFIG):
        case (0, action_type_util_1.REQUEST)(actions_1.GET_PLAY_FOR_POINTS_ACTIVITY):
        case (0, action_type_util_1.REQUEST)(actions_1.FETCH_DIGITAL_REVEAL_PLAYABLE):
            return __assign(__assign({}, state), { loading: true });
        case (0, action_type_util_1.SUCCESS)(actions_1.START_GAME):
            return __assign(__assign({}, state), { digitalRevealGame: action.payload });
        case (0, action_type_util_1.SUCCESS)(actions_1.GET_GAME_CONFIG):
            return __assign(__assign({}, state), { loading: false, errorMessage: null, gameConfig: action.payload ? action.payload.game : null, playForPointsActivity: action.payload ? action.payload.playForPointsActivity : null });
        case (0, action_type_util_1.SUCCESS)(actions_1.UPDATE_GAME_CONFIG):
            return __assign(__assign({}, state), { loading: false, errorMessage: null });
        case (0, action_type_util_1.SUCCESS)(actions_1.GET_PLAY_FOR_POINTS_ACTIVITY):
            return __assign(__assign({}, state), { loading: false, errorMessage: null, playForPointsActivity: action.payload ? action.payload.playForPointsActivity : null });
        case (0, action_type_util_1.SUCCESS)(actions_1.FETCH_DIGITAL_REVEAL_PLAYABLE):
            return __assign(__assign({}, state), { loading: false, errorMessage: null, digitalRevealGames: action.payload.data, digitalRevealGamesPaging: action.payload.page });
        case (0, action_type_util_1.FAILURE)(actions_1.UPDATE_GAME_CONFIG):
        case (0, action_type_util_1.FAILURE)(actions_1.GET_GAME_CONFIG):
        case (0, action_type_util_1.FAILURE)(actions_1.GET_PLAY_FOR_POINTS_ACTIVITY):
        case (0, action_type_util_1.FAILURE)(actions_1.FETCH_DIGITAL_REVEAL_PLAYABLE):
            return __assign(__assign({}, state), { loading: false, errorMessage: action.payload.message });
        default:
            return state;
    }
});
//# sourceMappingURL=reducers.js.map